var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['kiswe-spinner', ("kiswe-spinner--size-" + _vm.size)]},[_c('KisweIcon',{staticClass:"kiswe-spinner__icon",attrs:{"name":"loading","theme":_vm.theme}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }